import { FilterCategoryEnum } from "@common/utils/graphql";
import { Body } from "@hypercard/web-components";
import { CaretLeft } from "@phosphor-icons/react";
import { displayFilterCategory } from "./utils";

export const CategoryHeading = ({
  categoryOrCustomFieldName,
  onClick,
}: {
  categoryOrCustomFieldName: FilterCategoryEnum | string;
  onClick?: () => void;
}) => {
  const heading =
    displayFilterCategory(categoryOrCustomFieldName as FilterCategoryEnum) ??
    categoryOrCustomFieldName;
  return (
    <div
      className="group flex items-center gap-x-1 hover:text-white"
      onClick={onClick}
    >
      <CaretLeft weight="bold" className="size-4 shrink-0" />
      <Body
        size="sm"
        weight="medium"
        className="text-white/70 group-hover:text-white "
      >
        {heading}
      </Body>
    </div>
  );
};
